<template>
  <div class="comments publick">
    <div class="commentsLeft fl">
      <div class="commentContent">
        <div class="top">
          <div class="txt fl">综合<br>评分</div>
          <div class="starNum fl">{{info.comment_score}}</div>
          <div class="starDiv fl">
            <star :score="Number(info.comment_score)"></star>
          </div>
          <!--          <div class="allStar fr">-->
          <!--            <span>内容实用: <b>9.6</b> </span>-->
          <!--            <span>简洁易懂: <b>9.8</b> </span>-->
          <!--          </div>-->
        </div>
        <div class="choice">
          <div class="t fl">请评分：</div>
          <div class="star fl">
            <span @click="results(index)" v-for="(itemClass, index) in result" :key="index" :class="itemClass"
                  class="star-item"></span>
          </div>
        </div>
        <div class="textarea">
          <textarea v-model="content"></textarea>
        </div>
        <div class="bot">
          <div @click="addComment" class="save fr">确定</div>
        </div>
      </div>
      <ul>
        <li v-for="(item, index) in Comments.data" :key="index">
          <div class="img fl"><img :src="item.avatar" width="65" height="65" alt=""></div>
          <div class="Txt fr">
            <div class="name">
              <div class="fl">
                <span class="fl">{{item.username}}</span>
                <span class="starDiv fl">
                  <star :score="Number(item.score)"></star>
                </span>
              </div>
              <span class="fr">{{item.create_time}}</span>
            </div>
            <div class="p">{{item.content}}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="detRight fr">
      <detRight :pushcourse="pushcourse" :lecturer="lecturer"></detRight>
    </div>

    <div style="clear: both;"></div>
    <div class="page publick">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :total="Comments.count">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import star from '@/components/CourseDetails/star/star'
  import detRight from '@/components/CourseDetails/detRight/detRight'

  export default {
    components: {
      star,
      detRight
    },
    props: {
      info: {
        type: Object
      }
    },
    data () {
      return {
        page: 1,
        result: ['off', 'off', 'off', 'off', 'off'],
        content: '',
        starNum: 0,
        lecturer: [],
        pushcourse: [],
        Comments: {},
        id: ''
      }
    },
    created () {
      this.lecturer = this.$parent.info.lecturer
      this.pushcourse = this.$parent.pushcourse
      this.id = this.$parent.id
      this.getComments()
    },
    methods: {
      addComment () {
        if (this.content === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请输入评论内容'
          })
          return false
        }
        this.$http.post('/apipx/Course/addcomment', {
          px_course_id: this.id,
          score: this.starNum,
          content: this.content,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '评论成功',
              type: 'success',
              duration: 2000
            })
            this.starNum = 0
            this.getComments()
            this.$parent.getData()
            this.content = ''
            this.starNum = 0
          }
        })
      },
      pageChange (page) {
        this.page = page
        this.getComments()
      },
      results (index) {
        let result = []
        let score = (Math.floor(index + 1))
        for (let i = 0; i < score; i++) {
          result.push('on')
        }
        while (result.length < 5) {
          result.push('off')
        }
        this.starNum = (Math.floor(index + 1)) * 2
        this.result = result
      },
      getComments () {
        this.$http.post('/apipx/Course/comment', {
          px_course_id: this.id,
          p: this.page,
          row: 10,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.Comments = res
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .comments {
    color: #535353;
    margin-bottom: 100px;
    overflow: hidden;
    width: 1200px !important;

    .commentsLeft {
      .commentContent {
        margin-top: 40px;
        width: 700px;
        padding: 35px;
        box-shadow: 0px 0px 35px #f8f8f8;
        border-radius: 20px;
        overflow: hidden;

        .top {
          height: 38px;
          padding-bottom: 35px;
          border-bottom: 1px solid #ebebeb;

          .starNum {
            line-height: 38px;
            font-size: 38px;
            color: #404040;
            margin: 0 30px;
          }

          .starDiv {
            margin-top: 11.5px;

            .star {
              height: auto;
            }
          }

          .allStar {
            line-height: 38px;
            font-size: 16px;

            b {
              color: #ffa419;
              margin: 0 5px;
            }

            span {
              margin-left: 40px;
            }
          }
        }

        .choice {
          margin: 35px auto;
          overflow: hidden;

          .star {
            display: block;
            height: 15px;
            float: left;
            overflow: hidden;
            margin-top: 3px;

            .star-item {
              width: 15px;
              height: 15px;
              display: inline-block;
              font-size: 0;
              border: 0;
            }

            .on {
              background: url("../star/star-on.png") no-repeat center center;
              background-size: 100% 100%;
            }

            .off {
              background: url("../star/star-off.png") no-repeat center center;
              background-size: 100% 100%;
            }
          }
        }

        .textarea {
          width: 100%;
          height: 175px;
          border: 1px solid #f8f8f8;
          color: #535353;
          overflow: hidden;

          textarea {
            width: 100%;
            height: 100%;
            font-size: 14px;
            border: 0;
            line-height: 25px;
            text-indent: 10px;
          }
        }

        .bot {
          height: 35px;
          overflow: hidden;
          margin: 35px auto 0;
          width: 100%;

          .save {
            width: 100px;
            height: 35px;
            border-radius: 20px;
            background-color: #ff8484;
            color: #fff;
            text-align: center;
            line-height: 35px;
            cursor: pointer;
          }
        }
      }

      ul {
        margin-top: 20px;
        width: 700px;
        padding: 35px;
        box-shadow: 0px 0px 35px #f8f8f8;
        border-radius: 20px;
        overflow: hidden;

        li {
          overflow: hidden;
          margin-top: 35px;

          &:first-child {
            margin: 0;
          }

          .img {
            width: 85px;
            height: 85px;

            img {
              border-radius: 50%;
            }
          }

          .star {
            height: auto;
          }

          .Txt {
            width: 615px;

            .name {
              line-height: 25px;
              margin: 20px auto 0;
              width: 100%;
              height: 25px;
              overflow: hidden;

              .fl {
                font-size: 22px;
                margin-right: 20px;
              }

              .fr {
                font-size: 14px;
                color: #b3b3b3;
              }
            }

            .p {
              font-size: 14px;
              margin: 10px auto 0;
              line-height: 30px;
            }
          }
        }
      }
    }

    .page {
      height: 35px;
      margin: 50px auto;

      .el-pagination {
        width: 500px;
        margin: 0 auto;
      }

      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        border-radius: 50%;
        min-width: 33px;
        min-height: 33px;
        line-height: 33px;
        margin: 0 8px;

        &:hover {
          color: #ff8484;
        }
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #ff8484;
        color: #FFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseDetails/comments/comments.vue